import { useMutation, useQuery } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { fetchAbstractModelsWithIdentifiers } from "../api/abstractProduct.api";

interface UseAssociatedAbstractModelsProps {
  companyId?: number;
  identifiers?: string[];
}

const useAssociatedAbstractModels = ({
  companyId,
  identifiers,
}: UseAssociatedAbstractModelsProps) => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken]),
  );

  const {
    data: associatedAbstractModels,
    isLoading: isLoadingAssociatedAbstractModels,
    refetch,
  } = useQuery({
    queryKey: ["abstractModels", identifiers],
    queryFn: () =>
      fetchAbstractModelsWithIdentifiers(
        bearerToken as string,
        companyId,
        identifiers,
      ),
    enabled: !!identifiers?.length,
  });

  return {
    associatedAbstractModels,
    isLoadingAssociatedAbstractModels,
    refetchAssociatedModels: refetch,
  };
};

export default useAssociatedAbstractModels;
